import * as React from 'react';
import { IconSVGProps } from '../../../../../types/iconTypes';

export default ({ color = '#1A1A1A', ariaLabel }: IconSVGProps): React.ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-label={ariaLabel}>
    <g>
      <path
        d="M6.9956 5.96581L11.8642 10.8344L10.9042 11.7944L6.0356 6.92581L1.16703 11.7944L0.207031 10.8344L5.0756 5.96581L0.207031 1.16581L1.16703 0.205811L6.0356 5.07438L10.9042 0.205811L11.8642 1.16581L6.9956 5.96581Z"
        fill={color}
      />
    </g>
  </svg>
);
